module.exports = __webpack_public_path__ + "static/media/techcity.ef312b50.svg";